<template>
  <b-row>

    <!-- Fitlros -->
    <b-col cols="12" clas>
      <div v-b-toggle.collapse-data
        class="mt-3 shadow-sm px-4 py-2 pointer rounded w-100 w-full bg-gray-100 p-3 d-flex justify-content-between align-items-center"
        :class="visibleCollapseFIlters ? null : 'collapsed'" :aria-expanded="visibleCollapseFIlters ? 'true' : 'false'"
        aria-controls="collapse-data" @click="visibleCollapseFIlters = !visibleCollapseFIlters">
        <div>
          <i class="fa fa-filter" />
          <strong class="ml-2">{{ visibleCollapseFIlters ? 'Ocultar filtros' : 'Ver filtros' }}</strong>
        </div>
        <i :class="`fa ${!visibleCollapseFIlters ? 'fa-chevron-down' : 'fa-chevron-up'}`" />
      </div>
      <b-collapse id="collapse-1" v-model="visibleCollapseFIlters" class="my-4">
        <b-card class="shadow-sm border-none">

          <b-row>

            <!-- Inputs filter -->
            <b-col sm="12" md="12">

              <b-row>
                <b-col md="6" lg="4" xl="3">
                  <b-form-group>
                    <label for="nombre">Nombre</label>
                    <b-form-input name="nombre" type="text" v-model="filtro.nombre" @keyup.enter="fetchProductsIndexRpq" :disabled="loading" />
                  </b-form-group>
                </b-col>
                <b-col md="6" lg="4" xl="3">
                  <b-form-group>
                    <label for="sinonimo">Sinonimo</label>
                    <b-form-input id="sinonimo" name="sinonimo" type="text" v-model="filtro.sinonimos" @keyup.enter="fetchProductsIndexRpq" :disabled="loading" >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6" lg="4" xl="3">
                  <b-form-group>
                    <label for="id_fabricante">Fabricante</label>
                    <br />
                    <el-select id="id_fabricante" name="id_fabricante" v-model="filtro.id_fabricante" filterable
                      clearable multiple no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                      remote :remote-method="obtenerFabricantes">
                      <el-option v-for="fabricante in fabricantes" :key="fabricante.id" :label="fabricante.nombre"
                        :value="fabricante.id" />
                    </el-select>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="4" xl="3" v-if="allCountries && allCountries.length > 1">
                  <b-form-group>
                    <label for="country_id">País</label>
                    <el-select v-model="country_id" clearable size="sm" class="form-contol" placeholder="Selecciona un país">
                      <el-option v-for="country_sga in allCountries" :value="country_sga.country.id" :label="country_sga.country.name" :key="country_sga.country.id" />
                    </el-select>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="4" xl="3">
                  <b-form-group>
                    <label for="bases">Ubicaciones</label>
                    <br />
                    <treeselect v-model="val" :multiple="true" :defaultExpandLevel="Infinity" :options="treeWithChildrens"
                      value-consists-of="ALL_WITH_INDETERMINATE" @input="filtrarUbicaciones" placeholder="Buscar..."
                      :searchable="true" :show-count="true" :normalizer="normalizer" />
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="4" xl="3">
                  <b-form-group>
                    <label for="fecha">Fecha</label>
                    <br />
                    <el-date-picker v-model="filtro.confecha" id="range_date" name="range_date" type="daterange"
                      range-separator="a" value-format="yyyy-MM-dd" format="yyyy-MM-dd" start-placeholder="Fecha inicio"
                      end-placeholder="Fecha fin" class="w-100">
                    </el-date-picker>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="4" xl="3">
                  <label for="bases">Estado</label>
                  <el-select v-model="filtro.estado" size="sm" class="form-contol">
                    <el-option v-for="estado in estados" :value="estado.text" :label="estado.text" :key="estado.id"
                      :style="'background:' + estado.color + '; color: black;'" />
                  </el-select>
                </b-col>
                <b-col sm="12" md="6" lg="4" xl="3">
                  <b-form-group>
                    <label for="tipo">Tipo</label>
                    <el-select v-model="filtro.tipo" clearable :rows="3" :max-rows="6" name="type" id="type">
                      <el-option v-for="language in getAvailableTypes" :key="language.value" :label="language.text"
                        :value="language.value">
                      </el-option>
                    </el-select>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="4" xl="3">
                  <b-form-group>
                    <label for="campos">Disponible en el inventario</label>
                    <el-select v-model="filtro.in_use" clearable size="sm" class="form-contol"
                      @change="buscador(filtro, filtro.in_use)">
                      <el-option v-for="(in_use, index) in inUse" :value="in_use.value" :label="in_use.label"
                        :key="index" />
                    </el-select>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="4" xl="3">
                  <b-form-group>
                    <label for="bases">Caracterizados y Asignaciones</label>
                    <el-select v-model="filtro.product_status" clearable size="sm" class="form-contol">
                      <el-option
                          v-for="(productStatus,index) in productStatuses"
                          :value="productStatus.value"
                          :label="productStatus.label"
                          :key="index"
                      />
                    </el-select>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="4" xl="3">
                  <b-form-group>
                    <label for="bases">Tarjetas de Emergencia</label>
                    <el-select v-model="filtro.product_et" clearable multiple size="sm" class="form-contol">
                      <el-option
                          v-for="(productStatus,index) in productEt"
                          :value="productStatus.value"
                          :label="productStatus.label"
                          :key="index"
                      />
                    </el-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <!-- Botones filter -->
            <b-col cols="12" class="mt-2">
              <b-button class="mx-1" variant="primary" @click.prevent="fetchProductsIndexRpq">
                <i class="fa fa-search fa-lg"></i> Buscar
              </b-button>
              <b-button class="mx-1" @click.prevent="limpiar()">
                <i class="fa fa-eraser fa-lg"></i> Limpiar
              </b-button>
            </b-col>

          </b-row>

        </b-card>
      </b-collapse>
    </b-col>

    <!-- Tabla historico -->
    <b-col sm="12">

      <div class="d-flex justify-content-between align-items-center pt-1">
        <div>
          <b-checkbox
            id="selectorMultiple" name="selectorMultiple"
            v-model="filtro.selectorMultiple" @change="metodoSeleccion">
            Selección múltiple
          </b-checkbox>
        </div>

      <div class="content-btns justify-content-end align-items-center pt-1">
        <!-- Comentarios de productos -->
        <el-tooltip v-if="canSeeActionToComments" effect="dark" placement="top"
          content="Agregar comentario general." popper-class="py-1 px-2">
          <b-button variant="primary" @click="onHandleCommentProducts()">
            <i class="fa fa-commenting-o fa-lg text-white"></i>
          </b-button>
        </el-tooltip>

        <!-- Opciones de uso/desuso -->
        <b-dropdown v-if="validarPermisoComponente('empresa-editar-rpq')" id="id-options-uses" text="Opciones de Disponibilidad en el inventario" class="content-btns-btn m-md-2 sm:m-0mx-1 sm:w-full sm:w-100 md:w-auto" variant="primary">
          <b-dropdown-item @click.prevent="onHandleChangeUse(true)">Marcar como disponible en el inventario</b-dropdown-item>
          <b-dropdown-item @click.prevent="onHandleChangeUse(false)">Marcar como no disponible en el inventario</b-dropdown-item>
        </b-dropdown>

        <!-- Asignaciones de ubicaciones -->
        <b-button v-if="products_ids.length && validarPermisoComponente('empresa-editar-rpq')" class="content-btns-btn float-xl-right sm:m-0 mr-2 sm:w-full sm:w-100 md:w-auto" variant="primary"
          @click="openModalChooseLocations()">
          <i class="fa fa-map-marker fa-lg"></i> Asignar ubicaciones
        </b-button>

        <!-- Resumen de productos -->
        <b-button v-if="validarPermisoComponente('empresa-editar-rpq')" @click.prevent="mostrarModal()" class="content-btns-btn float-xl-right sm:m-0 md:mx-2 sm:w-full sm:w-100 md:w-auto" variant="primary">
          <i class="fa fa-list fa-lg"></i> Resumen
        </b-button>

        <!-- Procesar productos seleccionados -->
        <b-button v-if="filtro.selectorMultiple" @click="guardarProductosMasivo"
          class="content-btns-btn float-xl-right sm:m-0 mx-2 my-md-0 sm:w-full sm:w-100 md:w-auto" variant="primary">
          <i class="fa fa-floppy-o" /> Procesar seleccionados
        </b-button>
        </div>
      </div>

      <b-table class="b-table-asigns-m" style="font-size: 10pt;" responsive striped hover :items="productos.data"
        :fields="columnas" :tbody-tr-class="unClass" thead-tr-class="table-active" show-empty
        empty-text="No hay productos para mostrar">
        <template v-if="validarPermisoComponente('empresa-editar-rpq')" v-slot:cell(nombre)="data">
          <div class="d-flex">
            <b-form-checkbox @change="addProductIdToLocations(data.item)" :id="data.item.id.toString()" :name="data.item.id.toString()"
              :checked="products_ids.includes(data.item.id) ? true : false">
            </b-form-checkbox>
            <p>{{ data.item.nombre }} </p>
          </div>
        </template>

        <template v-if="validarPermisoComponente('asignar-rpq-masivo')" v-slot:head(asignado)="data">
          AsiRpq
          <b-button block size="sm" variant="warning" style="padding: 0" class="mt-1" v-b-tooltip.hover
            title="Marcar todos los productos como ASIGNADO RPQ" @click="asignarTodosLosProductos('asignado')">
            <i class="fa fa-check-square-o" />
          </b-button>
        </template>

        <template v-slot:head(pago)="data">
          Carac
          <b-button v-if="validarPermisoComponente('pagos-rpq-masivo')" block size="sm" variant="warning" style="padding: 0" class="mt-1" v-b-tooltip.hover
            title="Marcar todos los productos como PAGO" @click="asignarTodosLosProductos('pago')">
            <i class="fa fa-check-square-o" />
          </b-button>
        </template>

        <template v-slot:cell(sgaData)="data">
          <span v-if="data.item.sga.length > 0">SI</span>
          <span v-else>NO</span>
        </template>
        <template v-slot:cell(nfpaData)="data">
          <span v-if="data.item.nfpa != null">SI</span>
          <span v-else>NO</span>
        </template>
        <template v-slot:cell(unData)="data">
          <span v-if="data.item.u_n != null">SI</span>
          <span v-else>NO</span>
        </template>
        <template v-slot:cell(asignado)="data">
          <div class="d-flex justify-content-center aguardarProductosMasivolign-items-center">
            <b-form-checkbox
              :key="'asignado-' + checkboxKey + '-' + data.item.id"
              :id="'asignado' + data.item.id.toString()"
              :name="'asignado' + data.item.id.toString()"
              v-model="data.item.asignado"
              :checked="selectedAsignadoIds.includes(data.item.id)"
              :disabled="assignedDisabled(data.item)"
              @change="assignToRPQ(data.item)"
              :class="{'checkbox-selected': filtro.selectorMultiple && selectedAsignadoIds.includes(data.item.id)}"
              value="1"
              unchecked-value="0"
            />
          </div>
        </template>
        <template v-slot:cell(pago)="data">
          <div class="d-flex justify-content-center align-items-center">
            <b-form-checkbox
              :key="'pago-' + checkboxKey + '-' + data.item.id"
              :id="'pago' + data.item.id.toString()"
              :name="'pago' + data.item.id.toString()"
              v-model="data.item.pago"
              :checked="selectedPagoIds.includes(data.item.id)"
              :disabled="paymentDisabled(data.item.asignado, !data.item.pago)"
              @change="changeToCharacterized(data.item)"
              :class="{'checkbox-selected': filtro.selectorMultiple && selectedPagoIds.includes(data.item.id)}"
              value="1"
              unchecked-value="0"
            />
          </div>
        </template>

        <!-- En uso/no-uso el producto -->
        <template v-slot:cell(in_use)="data">
          <b-form-checkbox
            v-if="(typeof data.item.empresa_asignada === 'object' && 'in_use' in data.item.empresa_asignada)"
            :id="'in_use' + data.item.id.toString()" @change="changeUse(data.item)" :name="'in_use' + data.item.id.toString()"
            v-model="data.item.empresa_asignada.in_use" value="1" unchecked-value="0" :disabled="!validarPermisoComponente('empresa-editar-rpq')" />
        </template>

        <template v-slot:cell(te)="data">
          <div class="display:flex">
            <b-form-checkbox v-if="data.item.tarjeta_emergencia_empresa != null" :id="'te' + data.item.id.toString()" disabled
              @change="
                      asigna(
                        data.item.id,
                        'te',
                        data.item.tarjeta_emergencia_empresa.estado
                      )
                      " v-model="data.item.tarjeta_emergencia_empresa.estado" :name="'te' + data.item.id.toString()" value="1"
              unchecked-value="0">
              <!-- Cuando la TE se encuentra desactualizada -->
              <i v-if="data.item.tarjeta_emergencia_empresa.estado == 2" v-b-tooltip.hover
                title="La información se encuentra desactualizada"
                class="fa fa-exclamation-triangle warning-ico-te"></i>
            </b-form-checkbox>
          </div>
        </template>
        <template v-slot:cell(te_adj)="data">
          <div class="display:flex" @click.prevent="showModalnactiveTeAdj(data.item.te_adj.empresas_adjuntos)">
            <b-form-checkbox v-if="data.item.te_adj && data.item.te_adj.empresas_adjuntos && data.item.te_adj.empresas_adjuntos.activo"
              v-model="data.item.te_adj.empresas_adjuntos.activo" :name="'te_adj' + data.item.id" value="1"
              unchecked-value="0" :disabled="!validarPermisoComponente('empresa-editar-rpq')">
            </b-form-checkbox>
          </div>
        </template>


        <template v-slot:cell(notes)="data">
          <el-tooltip v-if="canSeeActionToComments" effect="dark" placement="top"
            content="Ver comentarios del producto." popper-class="py-1 px-2">
            <b-button variant="primary" size="sm"
              @click="onHandleShowModalToSeeDetails(data.item, data.item.empresa_asignada.id || '')">
              <i class="fa fa-commenting-o fa-lg text-white"></i>
            </b-button>
          </el-tooltip>
        </template>


      </b-table>
    </b-col>

    <!-- Footer -->
    <b-col>

      <!-- Boton de volver -->
      <b-button @click="backRoute()" size="sm" variant="secondary" class="float-left">
        <i class="fa fa-reply fa-lg"></i>
        Volver
      </b-button>

      <!-- Paginación -->
      <el-pagination v-if="productos.data && !!productos.data.length" v-model="filtro.page" @size-change="fetchProductsIndexRpq"
        @current-change="fetchProductsIndexRpq" :current-page.sync="filtro.page" class="float-right"
        :page-size.sync="filtro.perPage" :page-sizes="[10, 30, 50, 100]" layout="total, sizes, prev, pager, next"
        :total="productos.total" />
    </b-col>

    <!-- Modal resumen -->
    <b-modal v-model="modal_resumen" title="Resumen" hide-footer centered>
      <resumen />
    </b-modal>

    <!-- Fragmentos -->
    <modalTraceablePQComponent ref="modalTraceablePQComponentRef" :confirmAssigned="confirmActionTraceablePQ"
      :loading="loading" />

    <!-- Modal detalles -->
    <modalDetailsTraceablePQHistoryComponent :canCreateNotes="true" />

    <!-- Modal asignar ubicaciones -->
    <ModalAssignLocationProducts ref="modalAssignLocationProductsRef" @resetProductsIds="resetProductsIds"
      :products_ids="products_ids" />

    <!-- Modal para controlde trazavilidad de multiples productos al tiempo -->
    <ModalTraceableMultiplePQsComponent ref="modalTraceableMultiplePQsComponentRef"
      :actionOK="onHandleActionOKMultiplePQs" :actionCancel="onHandleActionCancelMultiplePQs"
      :payload="payloadActionMultiplPQs" />

    <!-- Modal para agregar comentarios generales a los productos -->
    <ModalGeneralCommentsPQsComponent ref="modalGeneralCommentsPQsComponentRef"
      :confirmAction="onHandleActionOKGeneralCommentsPQs" :actionCancel="onHandleActionCancelGeneralComments"
      :payload="payloadGeneralComments" />

    <!-- Barra informativa de selección múltiple -->
    <transition name="fade">
      <b-alert
        v-if="filtro.selectorMultiple"
        variant="info"
        class="info-bar-custom d-flex align-items-center"
        style="position: fixed; bottom: 0; left: 50%; transform: translateX(-50%); width: 600px; z-index: 9999; margin: 0;"
        show
      >
        <div class="container-info-bar d-flex align-items-center justify-content-between">
          <div class="items-selected d-flex align-items-center">
            <div class="items-counter-number">
              <strong>{{ selectedAsignadoIds.length + selectedPagoIds.length }}</strong>
            </div>
            <div class="items-counter-text">
              Elemento{{ (selectedAsignadoIds.length + selectedPagoIds.length) > 1 ? 's' : '' }} seleccionado{{ (selectedAsignadoIds.length + selectedPagoIds.length) > 1 ? 's' : '' }}
            </div>
          </div>
          <div class="items-actions d-flex align-items-center">
            <b-button size="sm" variant="primary" @click="guardarProductosMasivo">
              <i class="fa fa-floppy-o"></i> Procesar seleccionados
            </b-button>
            <b-button size="sm" variant="link" class="text-end clean-x-btn" @click="resetMultipleSelection" v-b-tooltip.hover>
              X
            </b-button>
          </div>
        </div>
      </b-alert>
    </transition>

  </b-row>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import Swal from "sweetalert2";
import Resumen from "./Resumen";
import ModalAssignLocationProducts from "./ModalAssignLocationProducts";
import useCompanyCountries from '@/composables/country/useCompanyCountries';
import useCompanyLocationsTree from '@/composables/location/useCompanyLocationsTree';

// Componentes
import modalTraceablePQComponent from '../../productos/asignacion/fragments/ModalTraceablePQ.vue'
import modalDetailsTraceablePQHistoryComponent from '../../history/assignPQ/fragments/ModalTraceablePQHistory.vue'
import ModalTraceableMultiplePQsComponent from '../../productos/asignacion/fragments/ModalTraceableMultiplePQs.vue'
import ModalGeneralCommentsPQsComponent from '../../productos/asignacion/fragments/ModalGeneralCommentsPQs.vue'

// Helpers
import { validarPermisoComponente } from '@/plugins/acl';

export default {
  name: "buscador-productos",
  mixins: [useCompanyCountries, useCompanyLocationsTree],
  props: {
    selectedCountryId: {
      type: [Number, String],
      default: null,
    },
  },
  components: {
    Treeselect,
    Resumen,
    modalTraceablePQComponent,
    modalDetailsTraceablePQHistoryComponent,
    ModalAssignLocationProducts,
    ModalTraceableMultiplePQsComponent,
    ModalGeneralCommentsPQsComponent
  },
  data() {
    return {
      modal_resumen: false,
      mostrar: false,
      checkboxKey: 0,
      columnas: [
        {
          key: "nombre",
          label: "Nombre",
          sortable: true,
          thStyle: { "min-width": "200px !important" },
          thClass: "align-middle text-uppercase",
        },
        {
          key: "sinonimos",
          label: "Sinónimos",
          sortable: true,
          thStyle: { "min-width": "120px !important" },
          thClass: "align-middle text-uppercase",
        },
        {
          key: "fabricante.nombre",
          label: "Fabricante",
          sortable: true,
          thStyle: {
            "min-width": "150px !important",
            width: "150px !important",
          },
          thClass: "align-middle text-uppercase",
        },
        {
          key: "sgaData",
          label: "SGA",
          sortable: true,
          thStyle: { "max-width": "70px !important", width: "70px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "nfpaData",
          label: "NFPA",
          sortable: true,
          thStyle: { "max-width": "70px !important", width: "70px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "unData",
          label: "UN",
          sortable: true,
          thStyle: { "max-width": "70px !important", width: "70px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "asignado",
          label: "AsiRpq",
          sortable: true,
          thStyle: { "max-width": "80px !important", width: "80px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "pago",
          label: "Pago",
          sortable: true,
          thStyle: { "max-width": "80px !important", width: "80px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "in_use",
          label: "Disponible en el inventario",
          sortable: true,
          thStyle: { "max-width": "155px !important", width: "155px !important" },
          thClass: "text-center align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "te",
          label: "TE gen",
          sortable: true,
          thStyle: { "max-width": "80px !important", width: "80px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "te_adj",
          label: "TE adj",
          sortable: true,
          thStyle: { "max-width": "80px !important", width: "80px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        }
      ],
      rangeYear: ["", ""],
      status: "",
      loading: false,
      val: null,
      previoSinVerificar: false,
      country_id: null,
      products_ids: [],
      payloadActionMultiplPQs: null,
      payloadGeneralComments: null,
      inUse: [
        {
          value: 1,
          label: 'SI'
        },
        {
          value: 0,
          label: 'NO'
        }
      ],
      productStatuses: [
        {
          value: 'assigned',
          label: 'Asignados'
        },
        {
          value: 'unassigned',
          label: 'Sin Asignar'
        },
        {
          value: 'paid',
          label: 'Caracterizados'
        },
        {
          value: 'unpaid',
          label: 'Sin caracterizar'
        }
      ],
      productEt: [
          {
            value: 'sinTE',
            label: 'Sin tarjeta de emergencia'
          },
          {
            value: 'te_gen',
            label: 'Con tarjeta de emergencia generada'
          },
          {
            value: 'te_adj',
            label: 'Con tarjeta de emergencia adjunta'
          }
      ],
      visibleCollapseFIlters: false,
      validarPermisoComponente: validarPermisoComponente,
      selectedAsignadoIds: [],
      selectedPagoIds: [],
    };
  },
  mounted() {
    if (validarPermisoComponente('acciones-comentarios-productos')) {
      this.columnas.push({
        key: "notes",
        label: "Comentarios",
        thClass: "text-center text-nowrap align-middle text-uppercase"
      });
    }
    this.initComponent();
  },
  watch: {
    selectedCountryId(nextState) {
      const normalizedCountryId = nextState || null;
      if (this.country_id !== normalizedCountryId) {
        this.country_id = normalizedCountryId;
      }
    },
    'allCountries'(nextState) {
      if (nextState && nextState.length > 1 && !this.country_id) {
        this.country_id = nextState[0].country.id;
      }
      if (nextState && nextState.length === 1) {
        this.country_id = nextState[0].country.id;
      }
      if (nextState && nextState.length === 0) {
        this.country_id = null;
      }
    },
    async 'country_id'(newVal) {
      const empresa_id = this.$route.params.id;
      this.$emit('change-country', newVal || null);

      this.val = null;
      this.setFiltroUbicacion([]);
      this.setFiltro({ ...this.filtro, country_id: newVal || null });

      if (this.locations_user && this.locations_user.length > 0) {
        this.loading = true;
        try {
          const ids = await this.loadLocationsTreeWithMultipleAutoSelect(empresa_id, this.locations_user, newVal || null, this.my_company);
          if (ids && ids.length > 0) {
            this.val = ids;
            this.setFiltroUbicacion(ids);
          }
        } finally {
          this.loading = false;
        }
        await this.fetchProductsIndexRpq();
      } else {
        await this.loadLocationsTree(empresa_id, newVal || null);
        await this.fetchProductsIndexRpq();
      }
    }
  },
  methods: {
    async initComponent() {
      if (this.$route.params.id) {
        await this.loadCountries(this.$route.params.id);
      }
    },
    async filtrarUbicaciones(ubicaciones) {
      if (this.loading) return;
      this.setFiltroUbicacion(ubicaciones);
      this.setFiltro({ ...this.filtro, ubicaciones });
      await this.fetchProductsIndexRpq();
    },
    async buscador(_filtro, _in_use) {
      await this.fetchProductsIndexRpq();
    },
    normalizer(node) {
      return {
        children: node.children && node.children.length ? node.children : 0,
      };
    },
    openModalChooseLocations() {

      if (this.$refs.modalAssignLocationProductsRef) {
        this.$refs.modalAssignLocationProductsRef.payload = {
          "locations": [],
          "products_ids": []
        }
        this.$refs.modalAssignLocationProductsRef.selecionadosIds = []
        this.$refs.modalAssignLocationProductsRef.initialSelection = []
      }

      this.$bvModal.show("modal_assign_locations_to_products")
    },
    async mostrarModal() {
      await this.getProductSummaryCompleted(this.$route.params.id);
      await this.cantidadSumaRpq({
        company_id: this.$route.params.id,
        country_id: this.country_id || null,
      });
      this.modal_resumen = true;
    },
    async metodoSeleccion(e) {
      if (!e) {
        if (this.validarRpqMasivo()) {
          await Swal.fire({
            title: "Guardar cambios",
            text: "¿Desea guardar los cambios seleccionados?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si",
            cancelButtonText: "No",
          }).then(async (result) => {
            if (result.value) {
              await this.guardarProductosMasivo();
            } else {
              this.limpiarRpqMasivoProductos();
              this.resetMultipleSelection();
              this.loading = true;
              await this.getProductsIndexRpq();
              await this.getProductSumByStatus({
                company_id: this.$route.params.id,
                country_id: this.country_id || null,
              });

              this.loading = false;
            }
          });
        }
      }
    },
    validarRpqMasivo() {
      const rpq_masivo = this.rpqMasivoProductos;

      return (
        !!rpq_masivo.verificado.length ||
        !!rpq_masivo.asignado.length ||
        !!rpq_masivo.pago.length ||
        !!rpq_masivo.te.length
      );
    },
    async guardarProductosMasivo() {
      if (!this.selectedAsignadoIds.length && !this.selectedPagoIds.length) {
        return;
      }

      // Construir el payload
      const assignedProducts = (this.rpqMasivoProductos.asignado || []).map(item => ({
        id_producto: item.id_producto,
        tipo: 'asignado',
        estado: item.estado
      }));
      const paidProducts = (this.rpqMasivoProductos.pago || []).map(item => ({
        id_producto: item.id_producto,
        tipo: 'pago',
        estado: item.estado
      }));
      const processProducts = [...assignedProducts, ...paidProducts];
      if (!processProducts.length) {
        this.loading = false;
        return;
      }

      this.loading = true;
      await this.guardarProductosMasivoRpq(processProducts);

      this.resetMultipleSelection();
      this.limpiarRpqMasivoProductos();

      await this.getProductsIndexRpq();
      await this.getProductSumByStatus({
        company_id: this.$route.params.id,
        country_id: this.country_id || null,
      });

      this.loading = false;
    },
        async limpiar(resetFilter = true) {
            this.setLoading(false);
            this.asignaEmpresa(this.$route.params.id);
            if(resetFilter) {
                this.resetFiltro();
                this.val = null;

                const defaultCountryId = (this.allCountries && this.allCountries.length)
                  ? this.allCountries[0].country.id
                  : null;
                const countryChanged = this.country_id !== defaultCountryId;

                this.country_id = defaultCountryId;

                if (!countryChanged) {
                  this.setFiltro({ ...this.filtro, country_id: defaultCountryId });
                  await this.fetchProductsIndexRpq();
                }
                return;
            }
            await this.fetchProductsIndexRpq();
        },
        unClass(item) {
            if (!item) return;
            if (!item.sga || !item.u_n) return 'table-danger';
            if (item.bloqueo == 1) return 'table-success';
            if (item.bloqueo == 0) return 'table-warning';
        },
        ...mapActions('empresa', [
            'getDiligenciados',
            'cantidadSumaRpq',
            'getProductSumByStatus',
            'getProductSummaryCompleted'
        ]),
        ...mapActions('productos_emp', [
            'getProductsIndexRpq',
            'getProductosEmpresa',
            'getEmpresaFiltro',
            'getBasesFiltro',
            'getAreasFiltro',
            'descargarAdjunto',
            'getCamposPersonalizados',
            'getProductoTarjeta',
            'setPagePagination',
            'guardaRpqProducto',
            'guardarProductosMasivoRpq',
            'obtenerFabricantes',
            'asignarTodosLosProductos'
        ]),
        async assignToRPQ(product){
            if (this.filtro.selectorMultiple) {
               // Modo selección múltiple
              const idx = this.selectedAsignadoIds.indexOf(product.id);
              if (idx === -1) {
                this.selectedAsignadoIds.push(product.id);
              } else {
                this.selectedAsignadoIds.splice(idx, 1);
                // Si se desmarca "Asignado al RPQ", también desmarcar "Caracterizado"
                const pagoIdx = this.selectedPagoIds.indexOf(product.id);
                if (pagoIdx !== -1) {
                  this.selectedPagoIds.splice(pagoIdx, 1);
                  product.pago = 0;
                  if (this.rpqMasivoProductos && this.rpqMasivoProductos.pago) {
                    const pagoIndex = this.rpqMasivoProductos.pago.findIndex(x => x.id_producto === product.id);
                    if (pagoIndex !== -1) {
                      this.rpqMasivoProductos.pago.splice(pagoIndex, 1);
                    }
                  }
                }
                product.asignado = 0;
                this.checkboxKey++;
              }
              this.setRpqMasivoProductos({
                  id_producto: product.id,
                  tipo: 'asignado',
                  estado: product.asignado
              });
              return;
            }
             // Modo individual - procesar inmediatamente
            const payload = {
                id_producto: product.id,
                tipo: 'asignado',
                estado: product.asignado,
                type: null,
                comments: null
            };
            this.loading = true;
            await this.synchronizeRPQProducts(payload);
        },
        async changeToCharacterized(product){
            if (this.filtro.selectorMultiple) {
              // Modo selección múltiple
              const idx = this.selectedPagoIds.indexOf(product.id);
              if (idx === -1) {
                this.selectedPagoIds.push(product.id);
              } else {
                this.selectedPagoIds.splice(idx, 1);
              }
                this.setRpqMasivoProductos({
                    id_producto: product.id,
                    tipo: 'pago',
                    estado: product.pago
                });
                return;
            }
             // Modo individual - procesar inmediatamente
            const payload = {
                id_producto: product.id,
                tipo: 'pago',
                estado: product.pago,
                type: null,
                comments: null
            };
            this.loading = true;
            await this.synchronizeRPQProducts(payload);
        },
    async changeUse(product) {
      try {


        this.setLoadingCancelProcess(false);
        this.setLoading(true);

        await this.getInfoAsignacion(product.id).then(async () => {

          if ('asignaciones' in this.selectedBuscaEmpr && this.selectedBuscaEmpr.asignaciones.length > 0) {

            this.selectedBuscaEmpr.asignaciones.map(async (asignation) => {
              if (asignation.id == this.selectedEmpresa.id) {

                const payload = {
                  product_id: product.id,
                  in_use: !asignation.in_use,
                  company_id: this.selectedEmpresa.id,
                };

                this.loading = false;
                this.setActionToTraceablePQ({
                  action: 'USE',
                  data: payload
                })
                this.$bvModal.show('modalTraceablePQComponent')

              }
            });

          }
        });

        this.setLoading(false);

      } catch (error) {
        Swal.fire({
          title: "Diligenciados",
          text: "Falla al tratar de intentar cambiar el estado del uso del diligenciado",
          icon: "warning",
          confirmButtonText: "Si"
        })
        await this.limpiar();
      }
    },
    /**
     * Se confirma la acción desde el modal y se procesa la acción necesaria.
     *
     * @param Boolean isSuccess
     * @param Object payload
     * @author Fernando Claros
     */
    async confirmActionTraceablePQ(isSuccess, payload) {

        if (!isSuccess) {
            this.loading = false;
            await this.limpiar(false);
            this.$bvModal.hide('modalTraceablePQComponent');
            this.setLoadingCancelProcess(false);
            return false;
        }
        const data = payload.data;
        const type = data.type;

        if(isSuccess && data.type != undefined && (data.type == 'pago' || data.type == 'asignado')) {
            this.synchronizeRPQProducts({id_producto: data.id, tipo: data.type, estado: data.status})
            .then(()=>this.$bvModal.hide('modalTraceablePQComponent'));
        } else {
            this.loading = true;
            await this.changeUseProductCompany({ ...payload.data, comments:this.traceable.comments, type: this.traceable.type })
            .then(async () => {
                this.$bvModal.hide('modalTraceablePQComponent');
                await this.limpiar(false)
            })
            .catch(async () => {
                this.$bvModal.hide('modalTraceablePQComponent');
                await this.limpiar(false)
            });
        }
    },
    /**
     * Abre el modal para mostrar los detalles del histórico, tipo Notas/Comentarios.
     *
     * @param {*} product
     * @param {*} assignId
     * @author Fernando Claros
     */
    async onHandleShowModalToSeeDetails(product, assignId) {
      this.setDataTraceable({
        assignId,
        company_id: this.selectedEmpresa.id,
        product_id: product.id,
        product: {
          ...product,
          company: this.selectedEmpresa
        }
      });

      this.$bvModal.show('modalTraceablePQHistoryComponent')
      await this.getTraceableByCompanyAndAssignId({
        load: 'ALL',
        assignId,
        company_id: this.selectedEmpresa.id,
        ...this.dataModalTraceable.table.data
      });
    },
    /**
     * Marcar los productos en uso o desuso.
     *
     * @param {boolean} action, true: todos en USO. false: Todos en DESUSO
     * @author Fernando Claros
     */
    onHandleChangeUse(action) {

      this.products_ids = this.productos.data.map(product => product.id);
      this.payloadActionMultiplPQs = { productIds: this.products_ids, action: action ? 1 : 0, companyId: this.selectedEmpresa.id };
      this.$bvModal.show('modalTraceableMultiplePQsComponent')

    },
    /**
     * Proceso de uso/desuso multiple confirmado.
     *
     * @param {boolean} action
     * @param {object} payload
     * @param {string|null} txtDescriptionProcess
     *
     * @author Fernando Claros
     */
    async onHandleActionOKMultiplePQs(payload) {
      await this.storeTraceableMultiple(payload).then(async () => {
        this.$refs.modalTraceableMultiplePQsComponentRef.onHandleCancel();
        await this.limpiar();
      });
    },
    /**
    * Proceso de uso/desuso multiple cancelado.
    *
    * @author Fernando Claros
    */
    onHandleActionCancelMultiplePQs() {

      this.payloadActionMultiplPQs = null
      this.products_ids = []
      this.$bvModal.hide('modalTraceableMultiplePQsComponent')

    },
    /**
    * Abrir modal para comentar los productos en masivo.
    *
    * @author Fernando Claros
    */
    onHandleCommentProducts() {

      this.products_ids = this.productos.data.map(product => product.id);
      this.payloadGeneralComments = {
        action: 2,
        productIds: this.products_ids,
        companyId: this.selectedEmpresa.id
      };
      this.$bvModal.show('modalGeneralCommentsPQsComponentId')

    },
    /**
    * Comentar los productos en masivo confirmado.
    *
    * @param Object payload - {comment, productsAction}
    *
    * @author Fernando Claros
    */
    async onHandleActionOKGeneralCommentsPQs(payload) {
      await this.storeGeneralComments({
        ...this.payloadGeneralComments,
        productIds: this.payloadGeneralComments.productIds,
        comments: payload.comment,
        productsAction: payload.productsAction,
        selectedProductsFilled: payload.selectedProductsFilled
      }).then(async () => {
        this.$refs.modalGeneralCommentsPQsComponentRef.onHandleCancel();
        await this.limpiar();
      });
    },
    /**
    * Comentar los productos en masivo, cerrar modal - cancelado.
    *
    * @author Fernando Claros
    */
    onHandleActionCancelGeneralComments() {
      this.payloadGeneralComments = null
      this.products_ids = []
      this.$bvModal.hide('modalGeneralCommentsPQsComponentId')

    },
        // Acciones del modulo de productos asignaciones
        ...mapActions("asignacionproductos", [
          "changeUseProductCompany",
          "getInfoAsignacion"
        ]),
        ...mapMutations('asignacionproductos', ['setLoadingCancelProcess']),
        ...mapMutations('productos_emp', [
            'setFiltro',
            'setFiltroBases',
            'setFiltroAreas',
            'limpiarProducto',
            'setPermisosAdmin',
            'setPermisosEmpresa',
            'resetFiltro',
            'resetProducts',
            'asignaEmpresa',
            'setFiltroUbicacion',
            'setRpqMasivoProductos',
            'limpiarRpqMasivoProductos'
        ]),
        // Estados para el modulo del Dashboard
        ...mapMutations('dashboard', {
          setLoading: 'load'
        }),
        // Mutaciones para el modulo: trazabilidad de asignaciones y usos
        ...mapMutations('assignPQTraceable', [
          'setDataTraceable',
          'setActionToTraceablePQ'
        ]),
        ...mapActions('empresa', ['getDiligenciados']),
        ...mapActions('adjuntos', ['assignCompanies', 'getTotalAttachmentsTECompany', 'getTipo']),
            // Acciones para el modulo: trazabilidad de asignaciones y usos
        ...mapActions('assignPQTraceable', [
          'getTraceableByCompanyAndAssignId',
          'storeTraceableMultiple',
          'storeGeneralComments'
        ]),
        async asigna(id, tipo, estado) {
            var dataCompact = {
                id_producto: id,
                tipo: tipo,
                estado: estado,
            };
            if (!this.filtro.selectorMultiple) {
                this.synchronizeRPQProducts(data);
            } else {
                this.setRpqMasivoProductos(dataCompact);
            }
        },
        async synchronizeRPQProducts(data) {
            const payload = { ...data, comments: this.traceable.comments, type: this.traceable.type };
            this.loading = true;
            await this.guardaRpqProducto(payload).then(async () => {
                await this.getTotalAttachmentsTECompany(this.$route.params.id)
            });
            await this.getProductsIndexRpq();
            await this.getProductSumByStatus({
              company_id: this.$route.params.id,
              country_id: this.country_id || null,
            });
            this.loading = false;
        },
    async showModalnactiveTeAdj(data) {
      if(!this.validarPermisoComponente('empresa-editar-rpq')) return;
      Swal.fire({
        title: "Inactivar TE Adjunta",
        text: "¿Está seguro de inactivar la tarjeta de emergencia?",
        icon: "warning",
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        confirmButtonColor: "#32696e",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Inactivar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.onHandleAssignCompanies(data)
        }
      });
    },
    async onHandleAssignCompanies(data) {
      let payload = {
        id: data.id_adjunto,
        company: data.id_empresa
      }
      await this.assignCompanies(payload).then(async () => {
        await this.getTotalAttachmentsTECompany(this.$route.params.id);
        await this.getProductsIndexRpq();
      });
    },
    addProductIdToLocations({id}) {
      if (!this.products_ids.includes(id)) {
        this.products_ids.push(id)
      } else {
        const index = this.products_ids.findIndex(item => item == id);
        this.products_ids.splice(index, 1)
      }
    },
    async resetProductsIds(){
      this.products_ids = [];
    },
    assignedDisabled(product) {
      if (!this.validarPermisoComponente('empresa-editar-rpq')) return true;
      return !!(product && product.asignado && product.pago);
    },
    paymentDisabled(asignado, pago) {
      return !this.validarPermisoComponente('empresa-editar-rpq') || !asignado;
    },
    backRoute(){
      const currentPath = this.$route.path;
      if (currentPath.includes("/my-company")) {
        this.$router.go(-1);
      }else {
        this.$router.push("/empresas");
      }
    },

    /**
     * Limpia los arrays de selección múltiple y recarga los productos.
     */

    async resetMultipleSelection() {
      this.selectedAsignadoIds = [];
      this.selectedPagoIds = [];
      this.limpiarRpqMasivoProductos();

      await this.getProductsIndexRpq();
      this.checkboxKey++;
    },
    /**
     * Sincroniza la visualización de los checks de la página actual según los arrays de seleccion múltiple.
     * Solo los productos cuyos ids estén en los arrays se muestran marcados, los demás según su valor real.
     */
    syncSelectedChecksWithPage() {
      if (!this.productos || !this.productos.data) return;
      this.productos.data.forEach(product => {
        if (this.filtro.selectorMultiple) {
          const asignadoObj = (this.rpqMasivoProductos && this.rpqMasivoProductos.asignado)
            ? this.rpqMasivoProductos.asignado.find(x => x.id_producto === product.id)
            : null;
          if (asignadoObj) {
            product.asignado = asignadoObj.estado;
          }
          const pagoObj = (this.rpqMasivoProductos && this.rpqMasivoProductos.pago)
            ? this.rpqMasivoProductos.pago.find(x => x.id_producto === product.id)
            : null;
          if (pagoObj) {
            product.pago = pagoObj.estado;
          }
        }
      });
      this.checkboxKey++;
    },

    /**
     * Obtiene la lista de productos desde el backend usando la acción Vuex mapeada,
     * sincroniza los checks de selección múltiple con la página actual y gestiona el estado de carga.
     *
     * @async
     * @returns {Promise<void>}
     * @author Nelson garcía
     */
    async fetchProductsIndexRpq() {
      if (this.loading) return;
      this.loading = true;
      try {
        await this.getProductsIndexRpq();
        this.syncSelectedChecksWithPage();
      } catch (error) {
        console.error('Error al obtener productos:', error);
      } finally {
        this.loading = false;
      }
    },
    },
    beforeDestroy() {
        this.asignaEmpresa(this.$route.params.id);
        this.resetFiltro();
        this.resetProducts();
    },
    computed: {
      ...mapState('empresa', ['selectedEmpresa']),
      ...mapState('asignacionproductos', ['selectedBuscaEmpr']),
        ...mapState('productos_emp', [
            'productos',
            'filtro',
            'empresas',
            'selectedProduct',
            'bases',
            'areas',
            'campos',
            'esAdmin',
            'esEmpresa',
            'rpqMasivoProductos',
            'fabricantes',
            'estados',
        ]),
        ...mapState("configurableVariables", ["allCountries"]),
        ...mapState("location", ["treeWithChildrens"]),
        ...mapState("autenticacion", ["locations_user", "my_company"]),
        ...mapState('productos', ['ubicEmpresa', 'arbolUbicaciones']),
        ...mapGetters('productos_emp', ['getParams']),
        // Estados del modulo: trazabilidad de asignaciones y usos
        ...mapState('assignPQTraceable', [
            'dataModalTraceable',
        'actionToTraceablePQ',
        'traceable'
      ]),
      ...mapState('adjuntos', ['tipos']),
      canSeeActionToComments() {
        return validarPermisoComponente('acciones-comentarios-productos');
      },
      canSeeActionToFilterAdjs() {
        return validarPermisoComponente('filtro-tipos-adjuntos');
      },
      getAvailableTypes() {
        return this.tipos.filter(x => (x.value !== 157 && x.value !== 177));
      }
    },
};
</script>

<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>

<style>
.border-none{
  border: none !important;
}
.pointer {
  cursor: pointer;
}
.border-check {
  border: 1.5px solid #cdcdcd;
  padding: 10px 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 4px;
  border-radius: 10px;
}

.el-input__inner {
  height: 32px;
}

.productos-faltantes-rpq {
  display: flex;
  justify-content: space-between;
}

@media only screen and (max-width: 675px) and (min-width: 575px) {
  .productos-faltantes-rpq {
    min-width: 100%;
  }
}

@media (min-width: 0px) and (max-width: 500px) {
  .content-btns{
    display: block !important;
  }
  .content-btns-btn{
    width: 100% !important;
    margin: 2px 0px !important;
  }
}

.content-btns {
  display: flex;
}

.el-date-editor .el-range-separator {
  line-height: 25px;
  width: 10%;
}

.el-date-editor--monthrange.el-input,
.el-date-editor--monthrange.el-input__inner {
  width: 100%;
}

.warning-ico-te {
  font-size: 15px;
  margin-top: 4px;
}

@media only screen and (max-width: 1488px) {
  .b-table-asigns-m {
    max-width: 64vw;
  }
}

@media only screen and (max-width: 1484px) {
  .b-table-asigns-m {
    max-width: 63.9vw;
  }
}

@media only screen and (max-width: 1480px) {
  .b-table-asigns-m {
    max-width: 63.8vw;
  }
}

@media only screen and (max-width: 1475px) {
  .b-table-asigns-m {
    max-width: 63.7vw;
  }
}

@media only screen and (max-width: 1471px) {
  .b-table-asigns-m {
    width: 936.7px;
  }
}

@media only screen and (max-width: 1470px) {
  .b-table-asigns-m {
    width: 935.7px;
  }
}

@media only screen and (max-width: 1469px) {
  .b-table-asigns-m {
    width: 934.7px;
  }
}

@media only screen and (max-width: 1468px) {
  .b-table-asigns-m {
    width: 933.7px;
  }
}


@media only screen and (max-width: 1467px) {
  .b-table-asigns-m {
    width: 932.7px;
  }
}

@media only screen and (max-width: 1466px) {
  .b-table-asigns-m {
    width: 931.7px;
  }
}

@media only screen and (max-width: 1465px) {
  .b-table-asigns-m {
    max-width: 62vw;
  }
}

@media only screen and (max-width: 1433px) {
  .b-table-asigns-m {
    width: 100%;
    max-width: 100%;
  }
}

@media (min-width: 1433px) and (max-width: 1900px) {
  .tab-content {
    min-width: auto !important;
    overflow-x: auto;
  }
}


@media (min-width: 1901px) and (max-width: 1963px) {
  .tab-content {
    min-width: auto !important;
    overflow-x: auto;
  }
}

.el-select__tags {
  flex-wrap: wrap;
}

.el-select__input {
  flex-basis: 100%;
  min-width: 100%;
  margin-top: 4px;
}

.checkbox-selected .custom-control-label::before {
  border: 2.5px solid #E0A800 !important;
  box-shadow: 0 0 4px 3px #FFC107 !important;
  border-radius: 6px !important;
}

.info-bar-custom {
  box-shadow: 0 -2px 8px rgba(0,0,0,0.08);
  padding: 8px;
  bottom: 10px !important;
  background: #f5e8ff !important;
  border-color: #097B83 !important;
  border-radius: 10px !important;
}

.container-info-bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.items-selected {
  display: flex;
  align-items: center;
  gap: 10px;
}

.items-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.items-counter-number {
  background-color: #097B83;
  border-radius: 3px;
  padding: 0 12px;
  color: #fff;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.items-counter-text {
  display: flex;
  align-items: center;
  line-height: 24px;
}

.clean-x-btn {
  font-size: 1rem;
  font-weight: 800;
  color: #097B83;
  padding: 6px 6px;
  line-height: 1;
  transition: all 0.2s ease;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.vue-treeselect__multi-value {
  max-height: 90px;
  overflow-y: auto !important;
}
</style>
